import { Row } from "antd"
import streamApi from "api/streamApi"
import { Streamer } from "models";
import { useEffect, useState } from "react"
import StreamerCard from "./StreamerCard";
import { useNavigate } from "react-router-dom";
import { useAppTranslation } from "app/hooks";

interface StreamerPlatformInterface {
  platform: string,
}

const StreamerPlatform: React.FC<StreamerPlatformInterface> = ({ platform }) => {
  const navigate = useNavigate();
  const t = useAppTranslation();
  const [streamers, setStreamers] = useState<Streamer[]>();
  const getStream = async () => {
    const { ok, body } = await streamApi.getStreamers({ size: 3, "platformName.contains": platform })
    if (ok && body) {
      setStreamers(body)
    }
  }

  useEffect(() => {
    getStream()
  }, [platform])

  return (
    <div className="streamer-wrapper">
      <div className="streamer-platform">
        <div className="view-more-container">
          <p className="streaming-title">{platform}</p>
          <p className="view-all" onClick={() => { navigate(`/stream/all-streamer?platform=${platform}`) }}>{t('casino.showAll')}</p>
        </div>
      </div>

      <div className="streamer-list">
        <Row className="relative" gutter={[8, 8]} wrap={true}>
          {
            streamers && streamers.map((item, index) => (
              <StreamerCard key={index} streamer={item} />
            ))
          }
        </Row>
      </div>
    </div>
  )
}

export default StreamerPlatform